import React, { useContext } from 'react';
import { useDeviationViewContext, MobileContext } from '../../../Context';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import ActionBarDesktop from './../../ActionBarDesktop';
import ActionBarLiterature from '../../ActionBarLiterature';
import ActionBarMobile from '../../ActionBarMobile';
import ActionBarFullscreen from '../../ActionBarFullscreen';
import SimpleActionBar from '../../SimpleActionBar';
import CommissionActionBar from '../../CommissionActionBar';
var ActionBarContent = function (_a) {
    var deviation = _a.deviation, _b = _a.loveMeterActive, loveMeterActive = _b === void 0 ? false : _b, isOwner = _a.isOwner;
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var isMobile = useContext(MobileContext);
    if (isFullscreen) {
        return React.createElement(ActionBarFullscreen, { deviation: deviation, isOwner: isOwner });
    }
    if (isMobile) {
        return (React.createElement(ActionBarMobile, { deviation: deviation, isOwner: isOwner, loveMeterActive: loveMeterActive }));
    }
    switch (getDeviationType(deviation)) {
        case DeviationTypes.STATUS:
        case DeviationTypes.POLL:
            return React.createElement(SimpleActionBar, { deviation: deviation, isOwner: isOwner });
        case DeviationTypes.COMMISSION:
            return React.createElement(CommissionActionBar, { deviation: deviation, isOwner: isOwner });
        case DeviationTypes.LITERATURE:
            return React.createElement(ActionBarLiterature, { deviation: deviation, isOwner: isOwner });
        default:
            return React.createElement(ActionBarDesktop, { deviation: deviation, isOwner: isOwner });
    }
};
ActionBarContent.displayName = 'ActionBarContent';
export default ActionBarContent;
//# sourceMappingURL=ActionBarContent.js.map